import { showErrorDialog } from 'v3/data/store/error/actions';
import { setProductValues } from 'v3/data/store/product/actions';
import { updateProduct } from 'v3/services/api';

export const changeProductPrice = async (skuStoreId: string, storePrice: number, available: boolean): Promise<void> => {
  try {
    await updateProduct(skuStoreId, { storePrice });
    setProductValues({
      id: skuStoreId,
      storePrice,
      available,
    });
  } catch (error) {
    showErrorDialog('Erro ao atualizar preço do produto', error);
  }
};
